var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBrowsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 23",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 7.375H3.4375C3.0578 7.375 2.75 7.6828 2.75 8.0625V17.6875C2.75 18.0672 3.0578 18.375 3.4375 18.375H15.8125C16.1922 18.375 16.5 18.0672 16.5 17.6875V8.0625C16.5 7.6828 16.1922 7.375 15.8125 7.375Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.375V5.3125C5.5 5.13016 5.57243 4.9553 5.70136 4.82636C5.8303 4.69743 6.00516 4.625 6.1875 4.625H18.5625C18.7448 4.625 18.9197 4.69743 19.0486 4.82636C19.1776 4.9553 19.25 5.13016 19.25 5.3125V14.9375C19.25 15.1198 19.1776 15.2947 19.0486 15.4236C18.9197 15.5526 18.7448 15.625 18.5625 15.625H16.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.125H16.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowsers);
export default __webpack_public_path__ + "static/media/icon-Browsers.23dbc7e996c40a2c22cdf719586b874d.svg";
export { ForwardRef as ReactComponent };